export function predict(x, powers, coefficients) {
    let y = 0;
    for (let k = 0; k < powers.length; k++) {
        y += coefficients[k] * x ** powers[k];
    }
    return y;
}
//# sourceMappingURL=predict.js.map